import React, { useEffect } from "react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./ServicePage.css"; // Updated CSS
import { BiRocket, BiSearchAlt, BiShield } from "react-icons/bi";
import { FaChartLine, FaPaintBrush, FaCode, FaShieldAlt,FaLightbulb, FaHeadset, FaCheckCircle, FaPhoneAlt, FaEnvelope, FaWhatsapp } from "react-icons/fa";
import { GiReceiveMoney } from "react-icons/gi"; // New Icon for Affordable Pricing
import ParticlesBackground from "../components/ParticlesBackground";


const getServiceIcon = (serviceName) => {
  switch (serviceName) {
    case "marketing":
      return <FaChartLine className="service-icon" />;
    case "graphic-design":
      return <FaPaintBrush className="service-icon" />;
    case "web-design":
    case "app-development":
    case "software-development":
      return <FaCode className="service-icon" />;
    case "cyber-security":
      return <FaShieldAlt className="service-icon" />;
    default:
      return <FaChartLine className="service-icon" />;
  }
};

const ServicePage = ({ isDarkMode }) => {


  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    serviceType: '',
    customService: '',
    message: '',
    budget: '',
    customBudget: '',
    deadline: '',
  });
  
  const [consultationData, setConsultationData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    website: '',
    serviceType: '',
    customService: '',
    projectDescription: '',
    problemStatement: '',
    existingSystem: '',
    communicationMethod: '',
    preferredDate: '',
    preferredTime: '',
    referralSource: '',
    additionalInfo: '',
  });
  
  
    const [statusMessage, setStatusMessage] = useState('');
    const [consultationStatusMessage, setConsultationStatusMessage] = useState('');
    const [showQuotePopup, setShowQuotePopup] = useState(false);
    const [showConsultationPopup, setShowConsultationPopup] = useState(false);
  

    const [showConsultationSuccessPopup, setShowConsultationSuccessPopup] = useState(false);
    
    const [showPopup, setShowPopup] = useState(false);
    const toggleQuotePopup = () => {
      if (!showQuotePopup) {
        setStatusMessage(""); // ✅ Clear status message only when opening
      }
      setShowQuotePopup(!showQuotePopup);
    };
    
    const toggleConsultationPopup = () => {
      if (!showConsultationPopup) {
        setConsultationStatusMessage(""); // ✅ Clear status message only when opening
      }
      setShowConsultationPopup(!showConsultationPopup);
    };
  
// Handle quote form submission
const handleFormSubmit = async (e) => {
  e.preventDefault();
  setStatusMessage('Sending...');

  try {
    const response = await fetch("https://astrasighttech.com/quote", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      setStatusMessage('Quote request sent successfully!');
      setShowQuotePopup(false); // Close the form
      setShowPopup(true); // Show success popup

      // Reset the form after successful submission
      setFormData({
        name: '',
        email: '',
        phone: '',
        serviceType: '',
        customService: '',
        message: '',
        budget: '',
        customBudget: '',
        deadline: '',
      });

      // Hide success message after 2 seconds
      setTimeout(() => {
        setShowPopup(false);
      }, 2000);
      
    } else {
      const data = await response.json();
      setStatusMessage(data.error || 'Failed to send request. Please try again.');
    }
  } catch (error) {
    setStatusMessage('Error sending request. Please try again later.');
  }
};


// Handle consultation form submission
const handleConsultationSubmit = async (e) => {
  e.preventDefault();
  setConsultationStatusMessage('Sending...');

  try {
    const response = await fetch("https://astrasighttech.com/consultation", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(consultationData),
    });

    if (response.ok) {
      setConsultationStatusMessage('Consultation request sent successfully!');
      setShowConsultationPopup(false); // Close the consultation popup
      setShowConsultationSuccessPopup(true); // Show success popup

      // Reset the consultation form after successful submission
      setConsultationData({
        name: '',
        email: '',
        phone: '',
        company: '',
        website: '',
        serviceType: '',
        customService: '',
        projectDescription: '',
        problemStatement: '',
        existingSystem: '',
        communicationMethod: '',
        preferredDate: '',
        preferredTime: '',
        referralSource: '',
        additionalInfo: '',
      });
// Open form & reset status message


      // Hide success popup after 2 seconds
      setTimeout(() => {
        setShowConsultationSuccessPopup(false);
      }, 2000);

    } else {
      const data = await response.json();
      setConsultationStatusMessage(data.error || 'Failed to send request. Please try again.');
    }
  } catch (error) {
    console.error("Consultation request error:", error);
    setConsultationStatusMessage('Error sending request. Please try again later.');
  }
};
    
    // Handle input change for quote form
    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    };
  
    // Handle input change for consultation form
    const handleConsultationInputChange = (e) => {
      const { name, value } = e.target;
      setConsultationData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    };
  
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  

  const [openFAQ, setOpenFAQ] = useState(null);

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };
  
  const faqs = [
    {
      question: `How long does it take to complete a project?`,
      answer: "Our timeline depends on the complexity of the project. On average, we deliver within 1-4 weeks."
    },
    {
      question: "What makes AstraSight different from others?",
      answer: `We combine expertise, innovation, and affordability to deliver high-quality solutions tailored to your business needs.`
    },
    {
      question: "Do you offer ongoing support?",
      answer: "Yes! We provide after-service support and maintenance to ensure your solution remains effective."
    },
    {
      question: "How do I get started?",
      answer: `Simply click the "Get Started" button on our service cards or contact us for a consultation.`
    }
  ];
  

  const { serviceName } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const serviceDetails = {
    marketing: {
      title: "Marketing",
      description: "We craft powerful marketing strategies that make your brand shine.",
      serviceCards: [
        {
          title: "Starter Package",
          price: "10,000",
          features: [
            "Basic Social Media Marketing",
            "SEO Setup & Optimization",
            "Basic Ad Campaign (Ksh 2,000 Budget)",
            "1 Custom Graphic Design",
            "Monthly Report & Insights",
          ],
        },
        {
          title: "Growth Package (Most Popular)",
          price: "15,000",
          features: [
            "Advanced Social Media Marketing",
            "Full SEO Optimization",
            "Targeted Ad Campaigns (Ksh 5,000 Budget)",
            "3 Custom Graphics",
            "Email Marketing Setup",
            "Weekly Performance Reports",
          ],
        },
        {
          title: "Business Booster Package",
          price: "20,000",
          features: [
            "Social Media & Google Ads Management",
            "Comprehensive SEO Strategy",
            "Retargeting & Conversion Tracking",
            "5 Custom Graphics & Video Ad",
            "Automated Email Campaigns",
            "Dedicated Account Manager",
          ],
        },
        {
          title: "Elite Domination Package",
          price: "30,000",
          features: [
            "Full Digital Domination Strategy",
            "Social Media, Google Ads & SEO",
            "Content Marketing & Blog Writing",
            "10 Custom Graphics & 2 Video Ads",
            "Influencer Marketing Collaboration",
            "24/7 Analytics & Monthly Strategy Calls",
          ],
        },
      ],
    },
    "graphic-design": {
      title: "Graphic Design",
      description: "We create visually stunning designs that enhance your brand identity.",
      serviceCards: [
        {
          title: "Starter Design Package",
          price: "8,000",
          features: [
            "Custom Logo Design",
            "Basic Brand Identity Guide",
            "2 Initial Logo Concepts",
            "3 Revisions",
            "High-Resolution Files",
          ],
        },
        {
          title: "Growth Branding Package (Most Popular)",
          price: "12,000",
          features: [
            "Logo & Full Brand Identity",
            "Business Card & Letterhead Design",
            "4 Initial Logo Concepts",
            "5 Revisions",
            "Social Media Kit (Profile & Cover Images)",
          ],
        },
        {
          title: "Business Premium Package",
          price: "18,000",
          features: [
            "Complete Business Branding Kit",
            "Custom Business Card & Stationery",
            "Social Media Graphics & Ad Creatives",
            "6 Initial Logo Concepts",
            "Unlimited Revisions",
            "High-Resolution Print & Digital Files",
          ],
        },
        {
          title: "Elite Creative Domination Package",
          price: "30,000",
          features: [
            "Full Corporate Identity Design",
            "Brochures, Flyers, & Poster Design",
            "Website UI/UX Mockups",
            "Illustrations & Custom Graphics",
            "Product Packaging Design",
            "Priority Support & Consultation",
          ],
        },
      ],
      
    },
    "web-design": {
      title: "Web Design",
      description: "Get a modern, responsive website tailored to your business.",
      serviceCards: [
        {
          title: "Starter Website Package",
          price: "15,000",
          features: [
            "Up to 5 Pages",
            "Responsive Design (Mobile & Desktop)",
            "Basic SEO Setup",
            "Contact Form Integration",
            "1 Revision",
          ],
        },
        {
          title: "Business Growth Package (Most Popular)",
          price: "25,000",
          features: [
            "Up to 10 Pages",
            "Advanced SEO Optimization",
            "Custom UI/UX Design",
            "Performance & Speed Optimization",
            "Basic CMS Integration (WordPress/Custom)",
            "3 Revisions",
          ],
        },
        {
          title: "E-Commerce Store Package",
          price: "35,000",
          features: [
            "Full E-Commerce Website",
            "Product Management System",
            "Payment Gateway Integration",
            "Advanced Security Features",
            "SEO & Conversion Optimization",
            "Admin Dashboard",
          ],
        },
        {
          title: "Elite Enterprise Solution",
          price: "50,000",
          features: [
            "Custom Web Application",
            "Advanced Database Integration",
            "API Development & Third-Party Integrations",
            "Enterprise-Level Security",
            "Unlimited Revisions & Ongoing Support",
            "Dedicated Project Manager",
          ],
        },
      ],
      
    },
    "software-development": {
      title: "Software Development",
      description: "Powerful software solutions designed to scale with your business.",
      serviceCards: [
        {
          title: "Starter Software Package",
          price: "50,000",
          features: [
            "Custom Desktop or Web App",
            "Basic Database Integration",
            "User Authentication System",
            "1 Revision",
            "Basic Support for 1 Month",
          ],
        },
        {
          title: "Business Automation Package (Most Popular)",
          price: "80,000",
          features: [
            "Advanced Business Software",
            "Custom Dashboard & Analytics",
            "API Integration & Automation",
            "Multi-User Access with Roles",
            "3 Revisions",
            "Support for 3 Months",
          ],
        },
        {
          title: "Enterprise Software Suite",
          price: "120,000",
          features: [
            "Scalable Enterprise Solution",
            "Cloud-Based Infrastructure",
            "Real-Time Data Processing",
            "Advanced Security & Encryption",
            "Custom Integrations & API Development",
            "Support for 6 Months",
          ],
        },
        {
          title: "Elite AI & Big Data Solution",
          price: "200,000",
          features: [
            "AI & Machine Learning Integration",
            "Big Data Processing & Analytics",
            "Custom Automation & Smart Features",
            "Enterprise-Level Security & Compliance",
            "Unlimited Revisions & Lifetime Support",
            "Dedicated Development Team",
          ],
        },
      ],
      
    },
    "cyber-security": {
      title: "Cyber Security",
      description: "Protect your business with top-notch security solutions.",
      serviceCards: [
        {
          title: "Basic Security Audit",
          price: "10,000",
          features: [
            "Vulnerability Scan",
            "Basic Risk Assessment",
            "Firewall & Network Inspection",
            "Security Best Practices Report",
            "1 Revision",
          ],
        },
        {
          title: "Advanced Protection Package (Most Popular)",
          price: "30,000",
          features: [
            "Full-System Penetration Testing",
            "Advanced Threat Detection",
            "Incident Response Plan",
            "Web & Network Security Optimization",
            "3 Revisions",
            "Support for 3 Months",
          ],
        },
        {
          title: "Enterprise Cyber Defense Suite",
          price: "60,000",
          features: [
            "24/7 Threat Monitoring",
            "Advanced AI-Powered Security",
            "Intrusion Detection & Prevention",
            "Secure Data Encryption & Backup",
            "Custom Security Policies & Compliance",
            "Dedicated Security Expert",
          ],
        },
        {
          title: "Ultimate Cyber Resilience Plan",
          price: "100,000",
          features: [
            "Full Cybersecurity Infrastructure",
            "Advanced AI & Machine Learning Defense",
            "Dark Web Monitoring & Threat Intelligence",
            "Cloud & Endpoint Security",
            "Unlimited Revisions & Lifetime Support",
            "Dedicated Team for Continuous Protection",
          ],
        },
      ],
      
    },
    "app-development": {
      title: "App Development",
      description: "Transform your ideas into powerful mobile applications with our cutting-edge development solutions.",
      serviceCards: [
        {
          title: "Starter App Package",
          price: "50,000",
          features: [
            "User Authentication & Registration",
            "Basic UI/UX Design",
            "Database Integration",
            "Push Notifications",
            "1 Revision",
          ],
        },
        {
          title: "Growth App Package (Most Popular)",
          price: "80,000",
          features: [
            "Custom Features & API Integrations",
            "Advanced UI/UX Design",
            "Cloud Storage Integration",
            "Performance Optimization",
            "3 Revisions",
            "Support for 3 Months",
          ],
        },
        {
          title: "Enterprise App Suite",
          price: "150,000",
          features: [
            "Cross-Platform Development (iOS & Android)",
            "Real-Time Database & Cloud Services",
            "AI & Machine Learning Integration",
            "Scalability & Load Testing",
            "Dedicated Developer Support",
            "Security & Compliance Implementation",
          ],
        },
        {
          title: "Ultimate Mobile Domination Package",
          price: "250,000",
          features: [
            "Complete App Ecosystem (Mobile + Web)",
            "Blockchain & AI-Powered Security",
            "High-Performance Custom Features",
            "App Store Optimization & Launch Strategy",
            "Unlimited Revisions",
            "Dedicated Full-Time Team",
          ],
        },
      ],
      
    },
  };

  const service = serviceDetails[serviceName];

  if (!service) {
    return <h1 className="service-not-found">Service Not Found</h1>;
  }

  return (
    <div className={`service-detail-container ${isDarkMode ? "dark-mode" : "light-mode"}`}>
 <section className={`service-intro ${isDarkMode ? "dark-mode" : "light-mode"}`}>
  <Helmet>
    <title>{`${service.title} Services in Nairobi - AstraSight Technologies`}</title>
    <meta
      name="description"
      content={`Unlock top-notch ${service.title} solutions tailored to elevate businesses in Nairobi and across Africa.`}
    />
    <meta
      name="keywords"
      content={`${service.title} services Nairobi, ${service.title} solutions Kenya, best ${service.title} company Africa`}
    />
    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Service",
        name: `${service.title} Services`,
        provider: {
          "@type": "Organization",
          name: "AstraSight Technologies",
          url: "https://astrasighttech.com",
        },
        areaServed: {
          "@type": "Country",
          name: "Kenya",
        },
        description: `Expert ${service.title} services to enhance your business in Nairobi and beyond.`,
      })}
    </script>
  </Helmet>

  {/* 🌐 Shared Particles Background */}
  <ParticlesBackground isDarkMode={isDarkMode} />

  <div className="service-intro-content">
    {getServiceIcon(serviceName)}
    <h2>{`${service.title} Solutions | AstraSight Technologies`}</h2>
    <p>
      Unlock the power of {service.title} with our expert solutions.
    </p>
  </div>
</section>


      {/* Service Cards */}
      {service.serviceCards && (
        <section className={`marketing-cards-container ${isDarkMode ? "dark-mode" : "light-mode"}`}>
          {service.serviceCards.map((card, index) => (
            <div 
              key={index} 
              className={`marketing-card ${index === 1 ? "popular-card" : ""}`}
            >
              <h3>{card.title}</h3>
              <p className="price">Ksh {card.price}</p>
              <ul className="features">
                {card.features.map((feature, i) => (
                  <li key={i}>{feature}</li>
                ))}
              </ul>
             
            </div>
          ))}
        </section>
      )}

<section  className= {`why-choose-us ${isDarkMode ? "dark-mode" : "light-mode"}`} >
  <h2>Why Choose Us?</h2>

  {/* Subheading */}
  <h3>Expertise in {service.title} with years of experience</h3>

  {/* Cards with Icons */}
  <ul className="cards-container">
     {/* Cutting-edge strategies */}
            <article className="card">
              <FaLightbulb className="icon" aria-label="Innovation" />
              <h3>Innovative Solutions</h3>
              <p>Cutting-edge strategies tailored for your business.</p>
            </article>
    
            {/* Affordable Pricing */}
            <article className="card">
              <GiReceiveMoney className="icon" aria-label="Affordable Pricing" />
              <h3>Cost-Effective</h3>
              <p>Affordable pricing with top-tier quality.</p>
            </article>
    
            {/* Dedicated Support */}
            <article className="card">
              <FaHeadset className="icon" aria-label="Customer Support" />
              <h3>24/7 Support</h3>
              <p>Dedicated support to ensure your success.</p>
            </article>
    
            {/* Proven Success */}
            <article className="card">
              <FaCheckCircle className="icon" aria-label="Proven Success" />
              <h3>Proven Results</h3>
              <p>Proven track record with satisfied clients.</p>
            </article>
  </ul>
</section>

{/* FAQs Section */}
<section className={`faqs ${isDarkMode ? "dark-mode" : "light-mode"}`}>
  <h2>Frequently Asked Questions</h2>
  <div className="faq-container">
    {faqs.map((faq, index) => (
      <div key={index} className={`faq-item ${openFAQ === index ? "open" : ""}`}>
        <div className="faq-question" onClick={() => toggleFAQ(index)}>
          {faq.question}
          <span className="faq-icon">{openFAQ === index ? "▲" : "▼"}</span>
        </div>
        {openFAQ === index && <p className="faq-answer">{faq.answer}</p>}
      </div>
    ))}
  </div>
</section>


<section className={`cta-section ${isDarkMode ? "dark-mode" : "light-mode"}`}>
      <div className="cta-content">
        <h2>🚀 Let’s Build Your Digital Success Story!</h2>
        <p>
          Transform your business with cutting-edge web design, SEO, and cybersecurity solutions.
        </p>

        {/* Benefits */}
        <div className="cta-benefits">
          <div className="cta-benefit-card">
            <BiRocket size={28} className="cta-icon" />
            <span>Modern & Responsive</span>
          </div>
          <div className="cta-benefit-card">
            <BiSearchAlt size={28} className="cta-icon" />
            <span>SEO-Optimized</span>
          </div>
          <div className="cta-benefit-card">
            <BiShield size={28} className="cta-icon" />
            <span>Secure & Scalable</span>
          </div>
        </div>

        {/* CTA Buttons */}
        <div className="cta-buttons">
            <button className="cta-button primary" onClick={toggleQuotePopup}>
              Get a Free Quote
            </button>
            <button className="cta-button secondary" onClick={toggleConsultationPopup}>
              Schedule a Consultation
            </button>
          </div>

        {/* Contact Info */}
        <div className="cta-contact">
        <div className="cta-contact-item">
  <a href="tel:+254791865638">
    <FaPhoneAlt size={18} className="cta-contact-icon" />
  </a>
  <a href="https://wa.me/254791865638" target="_blank" rel="noopener noreferrer">
    <FaWhatsapp size={20} className="cta-contact-icon whatsapp" />
  </a>
  <strong>+254 7918 656 38</strong>
</div>

      <div className="cta-contact-item">
        <FaEnvelope size={18} className="cta-contact-icon" />
        <strong>info@astrasighttech.com</strong>
      </div>
    </div>
      </div>
    </section>
    
    {/* Quote Popup */}
{showQuotePopup && (
  <div className={`popup-overlay ${isDarkMode ? "dark-mode" : "light-mode"}`}>
    <div className="popup-wrapper">
      <div className="popup-box">
        {/* Close Button */}
        <button className="popup-close" type="button" onClick={toggleQuotePopup}>✖</button>

        {/* Title */}
        <h3 className="title">Get a Free Quote</h3>
        <p className="subtitle">Provide some details about your project, and we'll send you a free quote.</p>

        {/* Form */}
        <form onSubmit={handleFormSubmit}>
          <input type="text" name="name" placeholder="Your Name" value={formData.name} onChange={handleInputChange} required />
          <input type="email" name="email" placeholder="Your Email" value={formData.email} onChange={handleInputChange} required />
          <input type="tel" name="phone" placeholder="Your Phone" value={formData.phone} onChange={handleInputChange} required />

          <select name="serviceType" value={formData.serviceType} onChange={handleInputChange} required>
            <option value="">Select Service Type</option>
            <option value="web-design">Web Design</option>
            <option value="ecommerce">E-commerce Website</option>
            <option value="seo-marketing">SEO & Digital Marketing</option>
            <option value="graphic-design">Graphic Design</option>
            <option value="software-dev">Custom Software Development</option>
            <option value="cybersecurity">Cybersecurity Services</option>
            <option value="other">Other</option>
          </select>

          {formData.serviceType === "other" && (
            <input type="text" name="customService" placeholder="Specify your service" value={formData.customService} onChange={handleInputChange} />
          )}

          <textarea name="message" placeholder="Describe your project" value={formData.message} onChange={handleInputChange} required />

          <select name="budget" value={formData.budget} onChange={handleInputChange} required>
            <option value="">Select Your Budget</option>
            <option value="20000-50000">Ksh 20,000 - 50,000</option>
            <option value="50000-100000">Ksh 50,000 - 100,000</option>
            <option value="100000+">Ksh 100,000+</option>
            <option value="custom">Custom Budget</option>
          </select>

          {formData.budget === "custom" && (
            <input type="text" name="customBudget" placeholder="Enter your budget" value={formData.customBudget} onChange={handleInputChange} />
          )}

          <label>Preferred Completion Date:</label>
          <input type="date" name="deadline" value={formData.deadline} onChange={handleInputChange} required />

          {/* Submit Button */}
          <button className="popup-submit" type="submit">Request Quote</button>

          {/* Status Message (for errors) */}
          {statusMessage && <p className="popup-status">{statusMessage}</p>}
        </form>
      </div>
    </div>
  </div>
)}

{/* Success Popup (appears after form is submitted) */}
{showPopup && (
  <div style={{
    position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
    background: 'white', padding: '20px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', borderRadius: '8px',
  }}>
    <p>{statusMessage}</p>
  </div>
)}


{/* Consultation Popup */}
{showConsultationPopup && (
  <div className={`popup-overlay ${isDarkMode ? "dark-mode" : "light-mode"}`}>
    <div className="popup-wrapper">
      <div className="popup-box">
        {/* Close Button */}
        <button className="popup-close" onClick={toggleConsultationPopup}>✖</button>

        {/* Form */}
        <form onSubmit={handleConsultationSubmit}>
          <h3 className="title">Book a Consultation</h3>
          <p className="subtitle">This form helps us understand your needs before offering services.</p>

          <div className="form-row">
            <input type="text" name="name" placeholder="Full Name" value={consultationData.name} onChange={handleConsultationInputChange} required />
            <input type="email" name="email" placeholder="Email Address" value={consultationData.email} onChange={handleConsultationInputChange} required />
          </div>

          <div className="form-row">
            <input type="tel" name="phone" placeholder="Phone Number" value={consultationData.phone} onChange={handleConsultationInputChange} required />
            <input type="text" name="company" placeholder="Company/Business Name (Optional)" value={consultationData.company} onChange={handleConsultationInputChange} />
          </div>

          <div className="form-row">
            <input type="text" name="website" placeholder="Business Website (if any)" value={consultationData.website} onChange={handleConsultationInputChange} />
            <select name="serviceType" value={consultationData.serviceType} onChange={handleConsultationInputChange} required>
              <option value="">Select a Service</option>
              <option value="Web Design">Web Design</option>
              <option value="Marketing">Marketing</option>
              <option value="Graphic Design">Graphic Design</option>
              <option value="SEO">SEO</option>
              <option value="Software Development">Software Development</option>
              <option value="Cybersecurity">Cybersecurity</option>
              <option value="Other">Other</option>
            </select>
          </div>

          {consultationData.serviceType === "Other" && (
            <input className="full-width" type="text" name="customService" placeholder="Please specify the service" value={consultationData.customService} onChange={handleConsultationInputChange} required />
          )}

          <textarea name="projectDescription" placeholder="Describe Your Project" value={consultationData.projectDescription} onChange={handleConsultationInputChange} required />

          <textarea name="problemStatement" placeholder="What Problem Are You Trying to Solve?" value={consultationData.problemStatement} onChange={handleConsultationInputChange} required />

          <div className="form-row">
            <select name="existingSystem" value={consultationData.existingSystem} onChange={handleConsultationInputChange} required>
              <option value="">Do you have an existing system or website?</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>

            <select name="communicationMethod" value={consultationData.communicationMethod} onChange={handleConsultationInputChange} required>
              <option value="">Preferred Communication Method</option>
              <option value="Email">Email</option>
              <option value="Call">Call</option>
              <option value="WhatsApp">WhatsApp</option>
              <option value="Other">Other</option>
            </select>
          </div>

          <div className="form-row">
            <input type="date" name="preferredDate" value={consultationData.preferredDate} onChange={handleConsultationInputChange} required />
            <input type="time" name="preferredTime" value={consultationData.preferredTime} onChange={handleConsultationInputChange} required />
          </div>

          <div className="form-row">
            <select name="referralSource" value={consultationData.referralSource} onChange={handleConsultationInputChange} required>
              <option value="">How did you hear about us?</option>
              <option value="Referral">Referral</option>
              <option value="Social Media">Social Media</option>
              <option value="Google">Google</option>
              <option value="Other">Other</option>
            </select>
          </div>

          <textarea className="full-width" name="additionalInfo" placeholder="Any Additional Information?" value={consultationData.additionalInfo} onChange={handleConsultationInputChange} />

          {/* Submit Button */}
          <button className="popup-submit" type="submit">Submit Consultation Request</button>

          {/* Status Message (for errors) */}
          {consultationStatusMessage && <p className="popup-status">{consultationStatusMessage}</p>}
        </form>
      </div>
    </div>
  </div>
)}

{/* Success Popup (Appears After Form Submission) */}
{showConsultationSuccessPopup && (
  <div style={{
    position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
    background: 'white', padding: '20px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', borderRadius: '8px',
  }}>
    <p>{consultationStatusMessage}</p>
  </div>
)}

    </div>
    
  );
};

export default ServicePage;
